<template>
  <div class="chat">
    <!-- 聊天 -->
    <div class="chat-msg">
      <!-- 联系人列表 -->
      <div class="msg-linkman">
        <div class="link-tabs">
          <div class="tab-item isTabsBorder">全部</div>
          <div class="tab-item">未读</div>
          <div class="tab-item">待处理</div>
        </div>
        <!-- 搜索 -->
        <div class="link-search">
          <a-input-search
              v-model:value="keyword"
              placeholder="姓名/房间名/订单号"
              @search="onSearch"
          />
        </div>
        <!-- 渠道 入住状态 -->
        <div class="link-select">
          <div class="select-s">
            <a-select ref="select" v-model:value="channel" style="width: 100%">
              <a-select-option value="jack">Jack</a-select-option>
              <a-select-option value="lucy">Lucy</a-select-option>
              <a-select-option value="Yiminghe">yiminghe</a-select-option>
            </a-select>
          </div>
          <div class="select-s">
            <a-select ref="select" v-model:value="channel" style="width: 100%">
              <a-select-option value="jack">Jack</a-select-option>
              <a-select-option value="lucy">Lucy</a-select-option>
              <a-select-option value="Yiminghe">yiminghe</a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 联系人列表 -->
        <div class="link-person">
          <a-spin :spinning="linkmanLoading">
            <div
                v-for="item in linkmanList"
                :key="item.unique"
                :style="{
                backgroundColor:
                  item.unique == recordInfo.unique ? '#f3f3f3' : '#ffffff',
              }"
                class="person-item"
                @click="getUserMsg(item)"
            >
              <div class="item-head">
                <a-avatar :src="item.head_img_url"/>
              </div>
              <div class="item-info">
                <div class="item-top">
                  <div class="top-name">{{ item.user_name }}</div>
                  <div class="top-time">
                    {{ item.lates_msg_time.substring(0, 16) }}
                  </div>
                </div>
                <div class="item-cont">{{ item.lates_msg }}</div>
                <div class="item-bom">
                  <div class="bom-icon">
                    <a-avatar :src="item.ota_info.logo" size="small"></a-avatar>
                  </div>
                  <div class="bom-type">
                    <span class="type-order">假2713金鸽名宿...</span>
                    <span class="type-stayIn">假待入住11-03 ~ 11-23</span>
                  </div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>
      </div>
    </div>
    <!-- 聊天框 -->
    <div class="chat-box">
      <!-- 联系人名称 -->
      <div class="box-name">
        {{ recordInfo.user_name }}-{{ recordInfo.ota_info?.name }}-{{
          recordInfo.ota_account
        }}
      </div>
      <!-- 内容 -->
      <div ref="contentRef" class="box-content">
        <a-spin :spinning="recordLoading">
          <div
              v-for="item in recordList"
              :key="item.unique"
              class="content-user"
          >
            <div class="user-time">{{ item.create_time }}</div>
            <!-- type=1 自己 -->
            <div v-if="item.type == 1" class="user-avatar-me">
              <div class="avatar-text">
                <div class="text">
                  {{ item.content }}
                </div>
                <div class="avatar-arrow"></div>
              </div>
              <div class="avatar-icon">
                <a-avatar :src="item.head_img_url"/>
              </div>
            </div>
            <!-- type=2 对方 -->
            <div v-else class="user-avatar">
              <div class="avatar-icon">
                <a-avatar :src="item.head_img_url"/>
              </div>
              <div class="avatar-text">
                <div class="text">
                  {{ item.content }}
                </div>
                <div class="avatar-arrow"></div>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
      <div class="box-send">
        <div class="send-inp">
          <a-textarea
              v-model:value="contentText"
              :autoSize="{
              minRows: 4,
            }"
              allowClear
              placeholder="输入内容"
              style="border: none"
          />
        </div>
        <div class="send-sub">
          <a-button type="primary" @click="handleSendText">发送</a-button>
        </div>
      </div>
    </div>
    <!-- 订单信息 快捷语 -->
    <div class="chat-shortcut">
      <div class="shortcut-order"></div>
      <div class="shortcut-news">
        <div class="news-title">
          <div class="title-name">快捷消息</div>
          <div class="title-oper">
            <edit-outlined
                style="color: #0094ff; margin-right: 6px; cursor: pointer"
            />
            <fund-projection-screen-outlined
                style="color: #0094ff; cursor: pointer"
            />
          </div>
        </div>
        <div class="news-list">
          <div class="list-item">
            <div class="item-title">问候语</div>
            <div class="item-text">你好，欢迎订房!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs} from "vue";
import save from "@/utils/crypte";
import {EditOutlined, FundProjectionScreenOutlined,} from "@ant-design/icons-vue";

export default {
  components: {
    EditOutlined,
    FundProjectionScreenOutlined,
  },
  setup() {
    const searchs = reactive({
      keyword: "",
      channel: "",
      checkStatus: "",

      onSearch() {
      },
    });

    const ws = reactive({
      contentText: "",
      handleSendText() {
      },

      scoket: "",
      path: `ws://192.168.1.1:9502?type=2&token=${
          JSON.parse(sessionStorage.getItem("landlordInfo")).token
      }`,

      wsSend() {
        console.log("加密-----", save.encrypt(ws.val));
        console.log("解密-----", save.decode(save.encrypt(ws.val)));

        // ws.scoket.send(save.encrypt(ws.val));
      },
      handleWsClose() {
        ws.scoket.onclose = ws.wsClose();
      },
      wsOpen() {
        console.log("Scoket 链接成功");
      },
      wsError() {
        console.log("链接错误");
      },
      wsClose() {
        console.log("Scoket 已经关闭");
      },

      // 格式化推送消息
      jsonMsg(params) {
        console.log(params);
        switch (params.event_type) {
          case "PMS_PUSH_USER_CONTACT_LIST":
            linkman.getLinkmanList(params.data);
            break;
          case "PMS_PUSH_USER_MSG":
            records.pushRecords(params.data);
            break;
          default:
            break;
        }
      },
      // 监听 websocket 推送消息
      onWsMessage(msg) {
        let datas = save.decode(msg.data);
        if (datas) {
          ws.jsonMsg(JSON.parse(datas));
        }
      },
    });

    // 联系人列表
    const linkman = reactive({
      linkmanLoading: true,
      // 获取联系人列表
      linkmanList: [],
      getLinkmanList(data) {
        linkman.linkmanList = data;
        linkman.linkmanLoading = false;
        records.getUserMsg(data[0]);
      },
    });

    // 联系人聊天内容
    const records = reactive({
      recordList: [],
      recordInfo: "",
      recordLoading: false,
      // 获取联系人聊天类容
      getUserMsg(params) {
        records.recordLoading = true;
        records.recordList = params.msg_detail;
        records.recordInfo = params;
        records.recordLoading = false;
      },
      // 递增数据
      pushRecords(params) {
        console.log(params);
        //  let a = records.recordList.some((item =>{
        //     // return item.unique
        //     console.log(item.unique);
        //     if(item.unique == params.to_unique){
        //       console.log('匹配成功~~');
        //       return
        //     }
        //   }))
        //   console.log(a);
      },
    });

    const msgs = reactive({
      contentRef: "",
    });
    onMounted(() => {
      nextTick(() => {
        msgs.contentRef.lastElementChild.scrollIntoView();
      });
    });

    return {
      ...toRefs(records),
      ...toRefs(linkman),
      ...toRefs(msgs),
      ...toRefs(searchs),
      ...toRefs(ws),
    };
  },
};
</script>

<style lang="scss" scoped>
.chat {
  background-color: #fff;
  border: 1px solid #ccc;
  width: 1200px;
  // min-height: 300px;
  margin: 0 auto;
  display: flex;
  height: calc(100vh - 80px);
  overflow: hidden;

  .chat-msg {
    height: 100%;

    .msg-linkman {
      height: 100%;
      width: 370px;

      .link-tabs {
        display: flex;
        justify-content: space-between;

        .tab-item {
          border-bottom: 1px solid #f3f3f3;
          flex: 1;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .isTabsBorder {
          border-bottom: 1px solid #0094ff !important;
        }
      }

      .link-search {
        padding: 10px;
      }

      .link-select {
        padding: 0 10px 10px;
        display: flex;

        .select-s {
          flex: 1;

          &:first-child {
            margin-right: 10px;
          }
        }
      }

      .link-person {
        background-color: #fff;
        overflow-y: scroll;
        height: calc(100% - 160px);

        .person-item {
          display: flex;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #ccc;

          .item-head {
            margin-right: 10px;
          }

          .item-info {
            flex: 1;

            .item-top {
              display: flex;
              justify-content: space-between;

              .top-name {
              }

              .top-time {
              }
            }

            .item-cont {
              padding: 6px 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 280px;
            }

            .item-bom {
              display: flex;
              align-items: center;
              font-size: 10px;

              .bom-icon {
              }

              .bom-type {
                span {
                  margin: 0 5px;
                }

                span.type-order {
                  border: 1px solid #ccc;
                  border-radius: 20px;
                  padding: 2px 6px;
                }

                span.type-stayIn {
                }
              }
            }
          }
        }
      }
    }
  }

  .chat-box {
    position: relative;

    height: 100%;
    flex: auto;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .box-name {
      height: 62px;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }

    .box-content {
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 0 10px;
      height: 100%;
      overflow-y: auto;

      .content-user {
        // background-color: pink;
        margin: 6px 0;

        .user-time {
          text-align: center;
          font-size: 10px;
        }

        // 自己
        .user-avatar-me {
          // background-color: pink;

          display: flex;
          align-items: center;
          justify-content: flex-end;

          .avatar-icon {
            margin-left: 10px;
          }

          .avatar-text {
            max-width: 350px;
            font-size: 10px;
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 6px;
            position: relative;
          }

          .avatar-arrow {
            width: 8px;
            height: 8px;
            position: absolute;
            right: 0;
            top: 44%;
            transform: translateX(50%) rotate(45deg);
            background-color: #fff;
            // border-width: 4px;
            border-right: 1px solid #ccc;
            border-top: 1px solid #ccc;
          }
        }

        // 对方
        .user-avatar {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .avatar-icon {
            margin-right: 10px;
          }

          .avatar-text {
            max-width: 350px;
            font-size: 10px;
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 6px;
            position: relative;
          }

          .avatar-arrow {
            width: 8px;
            height: 8px;
            position: absolute;
            left: 0;
            top: 44%;
            transform: translateX(-50%) rotate(45deg);
            background-color: #fff;
            // border-width: 4px;
            border-left: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
          }
        }
      }
    }

    .box-send {
      height: 160px;
      overflow-y: auto;

      .send-inp {
      }

      .send-sub {
        position: absolute;
        bottom: 6px;
        right: 6px;
      }
    }
  }

  .chat-shortcut {
    width: 312px;

    .shortcut-news {
      .news-title {
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px solid #ccc;

        .title-name {
        }

        .title-oper {
        }
      }

      .news-list {
        .list-item {
          cursor: pointer;
          display: flex;
          border-bottom: 1px solid #ccc;
          padding: 8px 10px;

          .item-title {
            font-weight: bold;
            margin-right: 10px;
          }

          .item-text {
          }
        }
      }
    }
  }
}
</style>